import { render } from "./InstitutionalForms.vue?vue&type=template&id=35001450&scoped=true"
import script from "./InstitutionalForms.vue?vue&type=script&lang=js"
export * from "./InstitutionalForms.vue?vue&type=script&lang=js"

import "./InstitutionalForms.vue?vue&type=style&index=0&id=35001450&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35001450"]])

export default __exports__